var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper",class:{ 'loader-background': _vm.isBackground }},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"app-loader",class:_vm.loaderClass})])
}
var staticRenderFns = []

export { render, staticRenderFns }